import { render, staticRenderFns } from "./ItemsMasterDetail.vue?vue&type=template&id=aceef91e&scoped=true&"
import script from "./ItemsMasterDetail.vue?vue&type=script&lang=js&"
export * from "./ItemsMasterDetail.vue?vue&type=script&lang=js&"
import style0 from "./ItemsMasterDetail.vue?vue&type=style&index=0&id=aceef91e&prod&scoped=true&lang=css&"
import style1 from "./ItemsMasterDetail.vue?vue&type=style&index=1&id=aceef91e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aceef91e",
  null
  
)

export default component.exports